module.exports = __webpack_public_path__ + "static/rightbackground-97e868d9c9ea66790b82200faa5fba82.png";